const AUTH_DETAIL_MARKERS = [
  "could not validate credentials",
  "invalid token",
  "token is invalid",
  "token expired",
  "jwt",
  "authenticate",
  "unauthorized",
  "авторизац",
  "аутентификац",
  "учетные данные",
  "учётные данные",
  "токен недейств",
  "токен истек",
];

type Auth401Context = {
  status?: number | string;
  url?: string;
  wwwAuthenticate?: string | null;
  detail?: unknown;
};

const normalizeDetail = (detail: unknown): string => {
  if (!detail) {
    return "";
  }
  if (typeof detail === "string") {
    return detail;
  }
  if (typeof detail === "object") {
    const payload = detail as Record<string, unknown>;
    if (typeof payload.detail === "string") {
      return payload.detail;
    }
    if (typeof payload.message === "string") {
      return payload.message;
    }
    try {
      return JSON.stringify(payload);
    } catch {
      return "";
    }
  }
  return String(detail);
};

export const shouldForceLogoutOn401 = ({
  status,
  url,
  wwwAuthenticate,
  detail,
}: Auth401Context): boolean => {
  const numericStatus = Number(status);
  if (numericStatus !== 401) {
    return false;
  }

  const normalizedUrl = String(url || "").toLowerCase();
  if (normalizedUrl.includes("/api/v1/login/token")) {
    return false;
  }

  const detailText = normalizeDetail(detail).toLowerCase();
  if (detailText.includes("clickup api token")) {
    return false;
  }

  const authHeader = String(wwwAuthenticate || "").toLowerCase();
  if (authHeader.includes("bearer")) {
    return true;
  }

  return AUTH_DETAIL_MARKERS.some((marker) => detailText.includes(marker));
};

export const clearStoredAuthSession = (): void => {
  localStorage.removeItem("authToken");
  localStorage.removeItem("token");
  localStorage.removeItem("currentUser");
};
